<template>
  <div class="message-support">
    <div class="support-top">
      <span class="support-top__system" :class="systemClass">
        <BaseIcon :name="systemIcon" size="14"/>
        {{ systemLabel }}
      </span>
    </div>

    <div class="message-support__block-body" :class="bodyClass">
      <div class="message-support__block-msg" v-html="parsed.html"/>
      <a v-if="parsed.downloadUrl" :href="parsed.downloadUrl" class="message-support__download">
        <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" x2="12" y1="15" y2="3"></line></svg>
        {{ $t("Download keys") }}
      </a>
    </div>
  </div>
</template>

<script>
import BaseIcon from '/webpack-assets/vue/components/BaseIcon.vue';

export default {
  components: {
    BaseIcon
  },
  props: {
    msg: { type: Object, required: true },
    currentUserUuidProp: { type: String, required: true },
    mobile: Boolean,
  },
  computed: {
    isAttention() {
      return this.msg.type === 3;
    },
    systemIcon() {
      return this.isAttention ? 'icon-attention' : 'icon-system';
    },
    systemLabel() {
      return this.isAttention
        ? this.$t('Attention')
        : this.$t('System message');
    },
    systemClass() {
      return { attention: this.isAttention };
    },
    bodyClass() {
      return this.isAttention ? 'attention' : 'system';
    },
    // The delivery message carries an inline "download" link to the order keys;
    // the design shows it as a separate button, so lift it out of the text.
    parsed() {
      const text = this.msg.text || '';
      if (this.isAttention || !text.includes('download-keys')) {
        return { html: text, downloadUrl: null };
      }
      const doc = new DOMParser().parseFromString(`<div>${text}</div>`, 'text/html');
      const link = doc.querySelector('a[href*="/order/download-keys"]');
      const href = link?.getAttribute('href') || '';
      let protocol = '';
      try {
        protocol = new URL(href, window.location.origin).protocol;
      } catch (e) {
        protocol = '';
      }
      if (protocol !== 'https:' && protocol !== 'http:') {
        return { html: text, downloadUrl: null };
      }
      const prev = link.previousSibling;
      if (prev && prev.nodeType === Node.TEXT_NODE) {
        prev.textContent = prev.textContent.replace(/\s*\/\s*$/, '');
      }
      link.remove();
      return { html: doc.body.firstChild.innerHTML, downloadUrl: href };
    },
  },
};
</script>
